import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { CodeStyle } from 'utils/code';

class BackendSecurity extends Component {

    render() {

        return (
            <>

            <Container>

                <Helmet>
                    <title>Security</title>
                    <meta name="description" content="Security" />
                </Helmet>

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers/development/backend" 
                    title={<span>Development</span>} breadcrumb_1="Backend"  breadcrumb_2="Security" 
                />
                
                <Card>
                    <CardHeader>
                        <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">Security</h3>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>

                                <h4>No Endpoint Left Exposed</h4>
                                <p className="text-sm">
                                    It's easy to write endpoints that any one can access. It's much harder to write endpoints that only the correct people can access.<br />
                                    Every project is different but security is of utmost import which is why all Architeck servers start out with built in endpoint authentication.<br />
                                    Unless custom security implementation is needed, this page details how all backend developers should authenticate an incoming request.
                                </p>


                                <p className="text-sm">
                                    Under the folder <b>/server/security</b> you will find a file called <b>authorizedTokenSent.js</b> <br />
                                    This function is simple, it takes in the headers of any api request as well as the res property created by Express.<br />
                                    If the headers contain a valid token the endpoint passes, if it does not, we send back an unauthorized status using the  
                                    {' '}<Link className="font-weight-bold" to="/developers/development/backend/responses">Single Property Check </Link> methodology.<br />

                                    Below you will find the code for this function:
                                </p>
<SyntaxHighlighter language="javascript" style={CodeStyle} customStyle={{padding: 15}}>
{`const keys = require('../../keys');

module.exports = (headers, res) => {

    const authorization = headers.authorization;

    //check authorization formatting
    if(!authorization || !authorization.includes(' ')) {
        res.send({success: false, message: 'Your authorization header was formatted incorrectly'});
        return false;
    }

    //get the api key off of the request headers. 
    const api_key = authorization.split(' ')[1];

    if(api_key !== keys.SYSTEM_API_KEY) {
        res.send({success: false, message: 'Unauthorized Request.'});
        return false;
    }

    return true;

}`}
</SyntaxHighlighter>    
 

                        <h4>Using this function</h4>
                        <p className="text-sm">
                            Since this function automatically returns a response to whomever requested this endpoint using it is simple. <br />
                            Just pass in the express headers and res to this function and wrap it in an if statement. The function takes care of the rest.
                        </p>
<SyntaxHighlighter language="javascript" style={CodeStyle} customStyle={{padding: 15}}>
{`const authorizedTokenSent = require('../../../security/authorizedTokenSent');
 

app.post(\`/api/v1/auth/password_update\`, async (req, res, next) => {

    if(authorizedTokenSent(req.headers, res)) {

        //proceed with request
        
    }

})`}
</SyntaxHighlighter>   
                        
                        <h4>Client Side Formatting</h4>
                        <p className="text-sm">This function looks for the authorization token in the form below  where headers.authorization is meant to match the environment variable "SYSTEM_API_KEY". If the two match the endpoint can proceed.</p>

<SyntaxHighlighter language="javascript" style={CodeStyle} customStyle={{padding: 15}}>
{`{
    authorization: "Bearer {{headers.authorization}}"
}`}
</SyntaxHighlighter>   

                    
                    </CardBody>
                </Card>
          
            </Container>
            </>
        );
    }
}

export default BackendSecurity